import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { PATHS } from '@/consts/paths'
import { collectCountRequest } from '@/store/modules/users/collections/reducer'

import { Collect, Grid, Home, Issued, Queries, Folder } from '../../Icons'
import { MenuItem } from '../MenuItem'

export const CarrierMenuItems = () => {
  const dispatch = useDispatch()

  const collectCount = useSelector((state) => state.users.collections.count)
  const collect = useSelector((state) => state.users.collections.active.collect)

  useEffect(() => {
    dispatch(collectCountRequest())
  }, [dispatch, collect])

  return (
    <>
      <MenuItem Icon={Home} label="Home" path={PATHS.user.home} />

      <MenuItem
        Icon={Grid}
        label="Pedidos"
        path={PATHS.user.ordersForCollect}
      />

      <MenuItem
        Icon={Collect}
        label="Coleta"
        path={PATHS.user.collect}
        badgeContent={collectCount}
      />

      <MenuItem Icon={Issued} label="Emitidas" path={PATHS.user.issueds} />

      <MenuItem
        Icon={Queries}
        label="Consultas"
        path={PATHS.user.queries.root}
      />

      <MenuItem Icon={Folder} label="Cadastros" path={PATHS.user.register} />
    </>
  )
}

export default CarrierMenuItems
